var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56.341 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.581 39.5H7.043V6.25A1.755 1.755 0 0 0 5.282 4.5H1.761A1.755 1.755 0 0 0 0 6.25V43a3.511 3.511 0 0 0 3.521 3.5h51.06a1.755 1.755 0 0 0 1.761-1.75v-3.5a1.755 1.755 0 0 0-1.761-1.75zM51.059 8H38.068a2.623 2.623 0 0 0-1.868 4.481l3.565 3.544-8.074 8.026-8.074-8.025a3.535 3.535 0 0 0-4.979 0l-7.558 7.513a1.743 1.743 0 0 0 0 2.475l2.489 2.474a1.768 1.768 0 0 0 2.49 0l5.069-5.039 8.072 8.025a3.535 3.535 0 0 0 4.979 0l10.564-10.5 3.565 3.544a2.643 2.643 0 0 0 4.508-1.856V9.75A1.753 1.753 0 0 0 51.059 8z",
    transform: "translate(0 -4.5)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.dfe08df9da2b04b64f64de1611390a95.svg";
export { ForwardRef as ReactComponent };